// Request plugin.
import { defaultOptions, parseOptions } from './configs'
import watchRequests from './sagas'
import eventsMap from './interface/events'
import createRequestHelper from './requestModule'
import { api, name } from './interface'

// Other plugins.
import { update as updateConfig } from '../config/interface/actions'
import { mapEvents } from '../events/interface/actions'

// Utils.
import { mergeValues } from '../common/utils'

// Libraries.
import { put } from 'redux-saga/effects'

/*
 * HTTP request plugin.
 */
export default pluginFactory()

/*
 * Platform-specific request plugins.
 *    Same base REST behaviour as the generic request plugin, with some extra
 *    handling of a response.
 */
export const linkRequest = pluginFactory('link')
export const ucRequest = pluginFactory('uc')
export const cpaasRequest = pluginFactory('cpaas')

/**
 * Factory function for creating a Request Plugin.
 *    Allows for specifying which platform the requests will be made to. This
 *    adds special handling of responses to check for special-case issues.
 * @param  {string} [platform] The platform this plugin is for.
 * @return {Function} The actual Plugin creator function.
 */
function pluginFactory (platform) {
  // Generate the saga for this platform, or a generic saga if platform is undefined.
  const saga = watchRequests(platform)

  return function request (options = {}, bottle) {
    options = mergeValues(defaultOptions, options)
    parseOptions(options)

    function * init () {
      yield put(updateConfig(options, name))
      yield put(mapEvents(eventsMap))
    }

    bottle.factory('sendRequest', createRequestHelper)

    return {
      sagas: [saga],
      init,
      capabilities: platform ? ['restAuthorization'] : [],
      api,
      name
    }
  }
}
